module.exports = __webpack_public_path__ + "img/7.ed47277e.jpg";